<template>
  <div class="layout-wrapper">   <!-- ← Single root element -->

    <!-- Side layout (1 row) -->
    <v-row
      v-if="sideLayout"
      class="pa-0 ma-0"
    >
      <v-col class="pa-0 ma-0 shrink">
        <v-img
          :src="`${groupData.logo_url.value}`"
          class="white--text align-end"
          v-if="groupData.logo_url"
          :style="groupData.logo_style.value"
        />
      </v-col>
      <v-col class="pa-0 ma-0 text-left grow">
        <v-card-title class="text-h5 text-left">
          {{ groupName }}
        </v-card-title>
      </v-col>
    </v-row>

    <!-- Default layout (2 rows) -->
    <template v-else>
      <!-- Logo row -->
      <v-row class="pa-0 ma-0">
        <v-col cols="12" class="pa-0 ma-0">
          <v-img
            :src="`${groupData.logo_url.value}`"
            class="white--text align-end"
            v-if="groupData.logo_url"
            :style="groupData.logo_style.value"
          />
        </v-col>
      </v-row>

      <!-- Title row -->
      <v-row
        class="pa-0 ma-0"
        align="center"
      >
        <v-col class="pa-0 ma-0 text-center">
          <v-card-title class="text-h5 justify-center text-center">
            {{ groupName }}
          </v-card-title>
        </v-col>
      </v-row>
    </template>

  </div>
</template>
<script>


export default {
  props: {
    groupData: {
      type: Object,
      required: true,
    },
  },
  data: () => ({

  }),
  methods: {
  
  },
  computed: {
   sideLayout () {

    return this.groupData && this.groupData.title_layout && this.groupData.title_layout.value === 'side'
   },
    groupName () {
      let name = ''
      if (this.groupData.group_name && this.groupData.group_name.value) {
        name = this.groupData.group_name.value.trim()
      }
      return name
    },
  },
  components: {

  },
}
</script>

<style scoped>
.layout-wrapper {
  display: contents;   
}
</style>

